import React, { useState } from "react";
import { useNavigate } from "react-router-dom";
import { Box, Button, Card, CardContent, Grid, Step, StepLabel, Stepper, Typography } from "@mui/material";
import CheckCircleIcon from "@mui/icons-material/CheckCircle";
import LocalShippingIcon from "@mui/icons-material/LocalShipping";
import RadioButtonUncheckedIcon from "@mui/icons-material/RadioButtonUnchecked";
import AddTaxRates from "../../../Modals/addtaxrates";

const orderTimeline = [
    {
        title: "Order Placed",
        date: "12/7/2025, 4:47:53 PM",
        completed: true,
        icon: <RadioButtonUncheckedIcon />,
    },
    {
        title: "Order Confirmed",
        date: "12/7/2025, 4:47:53 PM",
        completed: true,
        icon: <CheckCircleIcon />,
    },
    {
        title: "Order Shipped",
        date: "12/9/2025, 4:47:53 PM",
        tracking: "TRK-10001",
        completed: true,
        icon: <LocalShippingIcon />,
    },
    {
        title: "Order Delivered",
        date: "12/11/2025, 4:47:53 PM",
        completed: true,
        icon: <CheckCircleIcon />,
    },
];


const ViewInvoice: React.FC = () => {
    const navigate = useNavigate();

    // Static order data


    const payout = {
        vendorId: "SP-1001",
        vendorName: "TechHub Electronics",
        subscriptionType: "Premium",
        commission: "10%",
        payoutType: "7 Days",
        pendingAmount: "AED 4,250.00",
        lastPayoutDate: "15 Mar 2025",
        lastPayoutAmount: "AED 12,800.00",
        platformFees: "AED 1,250.00",
        shippingRate: "AED 15 / order",
    };

    const [openModal, setOpenModal] = useState(false);
    const handleCloseModal = () => {
        setOpenModal(false);
    };

    return (
        <>
            <div className="view_order_page">
                <div className="main_title d_flex">
                    <div className="left_s">

                        <h1>View Invoice</h1>
                        <p>
                            <button onClick={() => navigate("/dashboard")}>Dashboard</button> -{" "}
                            <button onClick={() => navigate("/vat-invoicing")}>
                                Vat & Invoicing
                            </button>{" "}
                            - View Invoice
                        </p>
                    </div>
                    <div className="right_s">
                        <Button className="btn btn_primary">Print</Button>
                    </div>
                </div>

                {/* Order Summary */}
                {/* Vendor Payout Summary */}
                <div className="invoice-container cards">

                    <div className="invoice-header">
                        <div className="company-info">
                            <h2>Bouteek Platform</h2>
                            <p>Dubai, UAE</p>
                        </div>

                        <div className="invoice-meta">
                            <p><strong>Invoice ID:</strong> INV-10045</p>
                            <p><strong>Invoice Type:</strong> Order</p>
                            <p><strong>Invoice Date:</strong> 18 Mar 2025</p>
                            <p><strong>Due Date:</strong> 25 Mar 2025</p>
                            <span className="status paid">PAID</span>
                        </div>
                    </div>


                    <div className="invoice-parties">
                        <div className="party-box">
                            <h4>Billed To (Customer)</h4>
                            <p><strong>John Doe</strong></p>
                            <p>john@email.com</p>
                            <p>+971 55 123 4567</p>
                            <p>Dubai, UAE</p>
                        </div>

                        <div className="party-box">
                            <h4>Vendor</h4>
                            <p><strong>TechHub Electronics</strong></p>
                            <p>Vendor ID: VND-1001</p>
                            <p>VAT Reg No: VAT-88991</p>
                            <p>support@techhub.com</p>
                        </div>
                    </div>


                    <table className="invoice-table">
                        <thead>
                            <tr>
                                <th>Item / Service</th>
                                <th>Description</th>
                                <th>Qty</th>
                                <th>Unit Price</th>
                                <th>Amount</th>
                            </tr>
                        </thead>
                        <tbody>
                            <tr>
                                <td>iPhone 14 Pro</td>
                                <td>Mobile Phone</td>
                                <td>1</td>
                                <td>AED 4,500.00</td>
                                <td>AED 4,500.00</td>
                            </tr>
                            <tr>
                                <td>Shipping</td>
                                <td>Express Delivery</td>
                                <td>1</td>
                                <td>AED 50.00</td>
                                <td>AED 50.00</td>
                            </tr>
                        </tbody>
                    </table>

                    <div className="invoice-summary">
                        <div className="summary-row">
                            <span>Subtotal</span>
                            <span>AED 4,550.00</span>
                        </div>

                        <div className="summary-row">
                            <span>Platform Fees</span>
                            <span>AED 150.00</span>
                        </div>

                        <div className="summary-row">
                            <span>Vat (%)</span>
                            <span>10%</span>
                        </div>

                        <div className="summary-row">
                            <span>Commission (10%)</span>
                            <span>AED 455.00</span>
                        </div>

                        <div className="summary-row">
                            <span>Shipping Charges</span>
                            <span>AED 50.00</span>
                        </div>

                        <div className="summary-row discount">
                            <span>Discount</span>
                            <span>- AED 100.00</span>
                        </div>

                        <div className="summary-row total">
                            <span>Total Amount</span>
                            <span>AED 5,105.00</span>
                        </div>
                    </div>


                    <div className="invoice-footer">
                        <p><strong>Payment Method:</strong> Credit Card</p>
                        <p><strong>Transaction Ref:</strong> TXN-774120</p>
                        <p>This is a system generated invoice.</p>
                    </div>
                </div>
            </div>
         
        </>
    );
};

export default ViewInvoice;
